export const customer_panoramic_selection = `
      first_name
      last_name
      full_name
      email_customer
      phone_customer
      country
      city
      zip
      address
      dob
      ip_address
      language
      pin
      profile
      state
`;

export const last_transaction_selection = `
      amount
      currency
`;

export const promocode_options_selection = `
      promocode_id
      title
      description
      percentage_value
      default_selected
      constraints {
        payment_methods
        processing_currencies
      }
`;

export const get_customer_last_transaction_promocodes_query = `
  query Get_customer_last_transaction_promocode_last_data ($fetchLastTransaction: Boolean!, $fetchPromoCodes: Boolean!, $active_intent: CashierIntent) {
    customer {${customer_panoramic_selection}}
    last_transaction(active_intent: $active_intent) @include(if: $fetchLastTransaction) {${last_transaction_selection}}
    promocode_options @include(if: $fetchPromoCodes) {${promocode_options_selection}}
  }
`;
